__turbopack_context__.v({
  "addToCartButton": "mobile-actions-module__zrH1BW__addToCartButton",
  "compareAtPrice": "mobile-actions-module__zrH1BW__compareAtPrice",
  "container": "mobile-actions-module__zrH1BW__container",
  "content": "mobile-actions-module__zrH1BW__content",
  "discountBadge": "mobile-actions-module__zrH1BW__discountBadge",
  "discountIcon": "mobile-actions-module__zrH1BW__discountIcon",
  "error": "mobile-actions-module__zrH1BW__error",
  "priceSection": "mobile-actions-module__zrH1BW__priceSection",
  "productImage": "mobile-actions-module__zrH1BW__productImage",
  "productInfo": "mobile-actions-module__zrH1BW__productInfo",
  "productPrice": "mobile-actions-module__zrH1BW__productPrice",
  "productTitle": "mobile-actions-module__zrH1BW__productTitle",
  "purchaseBadge": "mobile-actions-module__zrH1BW__purchaseBadge",
  "purchaseMeta": "mobile-actions-module__zrH1BW__purchaseMeta",
  "purchaseQuantity": "mobile-actions-module__zrH1BW__purchaseQuantity",
  "stickyAddToCart": "mobile-actions-module__zrH1BW__stickyAddToCart",
  "visible": "mobile-actions-module__zrH1BW__visible",
});
